<template>
  <div>
    <footer class="footer">
      <div class="feedback">
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="top-info">
              <h2>欢迎留言</h2>
              <p>Welcome to give us advice message</p>
              <el-form ref="feedbackForm" :rules="rules" :model="feedbackForm" label-width="80px">
                <el-form-item label="留言：" class="input-label" prop="content">
                  <el-input v-model="feedbackForm.content" placeholder="请输入留言的内容" style="width:80%;" type="textarea" size="medium"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" class="input-label" prop="email">
                  <el-input v-model="feedbackForm.email" placeholder="请输入邮箱" style="width:80%;padding:20px" size="medium"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="16">
              <el-col :span="2">
                <div style="float:left;padding:15px 0 0 0;border-right:1px solid #dddddd;height:300px;"></div>
              </el-col>
              <el-col :span="22">
                <h2>联系我们</h2>
                <hr />
                <div class="com-us">
                  <el-row :gutter="16">
                    <el-col :span="2">
                      <div class="us-img-1">
                        <img src="@/svg/iphone.svg" />
                      </div>
                    </el-col>
                    <el-col :span="22">13659293108</el-col>
                    <el-col :span="2">
                      <div class="us-img-2">
                        <img src="@/svg/email.svg" />
                      </div>
                    </el-col>
                    <el-col :span="22">592474298@qq.com</el-col>
                    <el-col :span="2">
                      <div class="us-img-1">
                        <img src="@/svg/adress.svg" />
                      </div>
                    </el-col>

                    <el-col :span="22">
                      <router-link to="relation" style="color:#FFF"> 陕西省西安市未央区中登国际企业中心A座1914室</router-link>
                    </el-col>
                    <el-col :span="2">
                      <div class="us-img-1">
                        <img src="@/svg/wechat.svg" />
                      </div>
                    </el-col>
                    <el-col :span="22">liufuqianf3108</el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

      <div class="footer-container">
        ©xingnian. All Right Reserved
        <div>
          <el-image style="width: 30px; height: 30px" :src="url" :fit="fit"></el-image>
        </div>

        <a style="text-decoration:none; text-indent: 2mm;color:#FFF" href="http://beian.miit.gov.cn">陕ICP备2020016935号</a>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: require('../../svg/reference.png'),
      rules: {
        content: [{ required: true, message: '请输入留言内容', trigger: 'blur' }],
        email: [{ required: true, message: '请输入完整邮箱', trigger: 'blur' }]
      },
      feedbackForm: {
        content: '',
        email: ''
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs['feedbackForm'].validate(async valid => {
        if (valid) {
          const axios = require('axios')
          axios
            .post('http://127.0.0.1:7001/feedback', {
              content: this.feedbackForm.content,
              email: this.feedbackForm.email
            })
            .then(function(response) {
              console.log(response)
            })
            .catch(function(error) {
              console.log(error)
            })
          console.log(this.feedbackForm)
          this.$message({
            type: 'success',
            message: '提交成功，感谢您的建议，我们会将及时回复您！'
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scope>
.footer {
  // position: absolute;
  // bottom: 0;
  padding: 10px 0;
  height: 450px;
  background-color: #111111;
  width: 100%;
  .feedback {
    color: #fff;
    width: 70%;
    height: 90%;
    margin: 0 auto;
    // background-image: url('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1600335961081&di=5cae3d29397a08b3b95b956d13d26b59&imgtype=0&src=http%3A%2F%2Fpic26.nipic.com%2F20121214%2F4572067_172640547000_2.jpg');
    background-image: url('../../assets/bg.png');
    .top-info {
      text-align: center;
      .el-textarea {
        .el-textarea__inner {
          height: 100px;
        }
      }
      .el-form .el-form-item .el-form-item__label {
        color: #fff;
        font-size: 18px;
        margin-top: 16px;
      }
    }
    .us-img-1 img {
      width: 40px;
      height: 40px;
    }
    .us-img-2 img {
      width: 35px;
      height: 35px;
    }
    .com-us {
      .el-row .el-col-22 {
        height: 50px;
        font-weight: bold;
        font-size: 24px;
      }
    }
  }
  .footer-container {
    color: #fff;
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    line-height: 40px;
    justify-content: center;
  }
}
</style>
